/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';

import {ReactiveFormsModule} from '@angular/forms';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {TranslateModule} from '@ngx-translate/core';
import {FieldLabelComponent} from '../field-label/field-label.component';
import {IxModule} from '@siemens/ix-angular';

@Component({
  selector: 'app-boolean-input',
  imports: [
    FieldLabelComponent,
    IxModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
  templateUrl: './boolean-input.component.html',
  styleUrl: '../input-components.scss',
})
export class BooleanInputComponent extends BaseFormFieldDirective {
  constructor() {
    super();
  }

  /**
   * Ensures the boolean control always holds a concrete `false` value when the
   * passport data does not provide an initial value for this field.
   *
   * Without this override the control would start as `null` or `undefined`
   * because `BaseFormFieldDirective` initialises the control from raw passport
   * data, which may omit optional boolean fields entirely.
   */
  override onControlValueInitialized() {
    super.onControlValueInitialized();
    const value = this.control.getRawValue();
    if (!value) {
      this.control.setValue(false, {emitEvent: false});
    }
  }
}
